module.exports = __webpack_public_path__ + "img/mujer.6521eda0.svg";